module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Mixer-0cdb880dc13f79af50903f896fef1124.svg";